module.exports = __webpack_public_path__ + "img/honor4.225837ea.png";